<div
  class="user-management-container"
  *ngIf="currentUser$ | async as currentUser"
  (click)="dropdown.toggle()"
  data-cy="header-user-management-dropdown"
>
  <common-mojo-avatar
    [id]="currentUser.photoId"
    [selectedPhotoShape]="avatarPhotoShape"
    [initials]="initials$ | async"
    [backgroundSize]="avatarBackground"
  ></common-mojo-avatar>
  <span class="user-name">{{currentUser.firstName}}
    {{currentUser.lastName}}</span>
</div>
<mojo-dropdown
  #dropdown
  [closeWhenClickedInside]="true"
  [fullWidthOnMobile]="false"
>
  <ng-container *ngIf="isEnabledForPBIUser">
    <a
      class="mojo-dropdown-menu-item"
      [routerLink]="['/account/profile']"
      data-cy="header-account-settings-button"
      *mojoHasPrivilege="privileges.settings.profile"
    >
      Account Settings</a>
    <a
      class="mojo-dropdown-menu-item"
      [routerLink]="['/users']"
      data-cy="header-users-link"
      *mojoHasPrivilege="privileges.settings.user"
    >
      User management
    </a>
    <a
      class="mojo-dropdown-menu-item"
      [routerLink]="['/api-keys']"
      *mojoHasFeatureExtension="apiKeyFE"
    >
      API management
    </a>
    <a
      class="mojo-dropdown-menu-item"
      [routerLink]="['/job-boards']"
      data-cy="header-job-board-link"
      *mojoHasPrivilege="privileges.jobBoards.viewPage"
    >
      Job boards
    </a>
  </ng-container>
  <a
    class="mojo-dropdown-menu-item"
    data-cy="header-logout-button"
    (click)="logout($event)"
  >
    Log out</a>
</mojo-dropdown>
